import * as icons from 'simple-icons';

const ICONS = Object.values(icons);

export default ICONS;
